import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../../ui/button';

export interface BaseConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  icon?: string;
  children: React.ReactNode;
  onSubmit: () => void;
  submitText: string;
}

export const BaseConfigModal: React.FC<BaseConfigModalProps> = ({
  isOpen,
  onClose,
  title,
  icon,
  children,
  onSubmit,
  submitText
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md bg-[#0F1629] rounded-xl border border-gray-800/50 p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-4">
            {icon && (
              <div className="p-2 rounded-lg bg-gray-800/50">
                <img src={icon} alt={title} className="h-8 w-8" />
              </div>
            )}
            <h3 className="text-lg font-semibold text-white">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-300 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}>
          <div className="space-y-4">
            {children}
          </div>

          <div className="flex items-center justify-end space-x-3 mt-8 pt-6 border-t border-gray-800">
            <Button variant="outline" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">
              {submitText}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};